import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "AccountLogin" })
export default class AccountLogin extends Vue {
    public localizer: any = Localizer;
    public formHelper: any = FormHelper;
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public options: any = null;
    public formData: any = {};
    public validationErrors: any[] = [];

    @Prop() readonly returnUrl: string;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        this.options = (await Axios.post(this.routes.Account_GetOptions, null)).data;
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        try {
            await Axios.post(this.routes.Account_Login, this.formData);

            this.isSuccess = true;

            GTagHelper.sendCustomEvent("login", { method: "On Site" });

            window.location.href = this.returnUrl ? this.returnUrl : "/";
        } catch (error) {
            this.formData.password = null;

            if (error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }

    public returnLink(): string {
        return this.returnUrl ? this.routes.Account_Register + '?returnurl=' + this.returnUrl : this.routes.Account_Register;
    }

    public setExternaAnalytics() {
        GTagHelper.sendCustomEvent("login", { method: "Google" });
    }

    public isEmailNotConfirmed(): boolean {
        return (this.validationErrors.length !== 0 && this.validationErrors.some(x => x.message === this.localizer.get("Account.Common.Login_EmailNotConfirmed")));
    }
};